/**
 * 前台相册 API
 */
import client from './client';

export interface Photo {
  id: string;
  albumId: string;
  url: string;
  thumbUrl: string;
  title: string | null;
  titleEn: string | null;
  width: number;
  height: number;
  sortOrder: number;
  isFeatured: boolean;
  createdAt: string;
  album?: {
    id: string;
    title: string;
    titleEn: string | null;
  };
}

export interface Album {
  id: string;
  title: string;
  titleEn: string | null;
  description: string | null;
  descriptionEn: string | null;
  tags: string[];
  coverUrl: string | null;
  photoCount: number;
  photos?: Photo[];
  createdAt: string;
}

/**
 * 获取已发布相册列表
 */
export const getAlbums = async (tag?: string): Promise<Album[]> => {
  const url = tag ? `/albums?tag=${encodeURIComponent(tag)}` : '/albums';
  return client.get(url);
};

/**
 * 获取相册详情
 */
export const getAlbum = async (id: string): Promise<Album> => {
  return client.get(`/albums/${id}`);
};

/**
 * 获取所有标签
 */
export const getAlbumTags = async (): Promise<string[]> => {
  return client.get('/albums/tags');
};

/**
 * 获取精选照片
 */
export const getFeaturedPhotos = async (limit = 8): Promise<Photo[]> => {
  return client.get(`/albums/featured?limit=${limit}`);
};
